import { makeStyles } from 'tss-react/mui';
import { PlatformLinkingConnectionStatus } from '@okletsplay/core';

export const useStyles = makeStyles<{ status?: PlatformLinkingConnectionStatus }>()(
  (theme, { status }) => ({
    root: {
      cursor: status === PlatformLinkingConnectionStatus.NotConnected ? 'pointer' : 'default',
      userSelect: 'none',
      display: 'flex',
    },

    unlink: {
      color: theme.palette.text.primary,
    },

    icon: {
      marginTop: theme.spacing(-0.75),
      marginBottom: theme.spacing(0.25),
    },
  })
);
